import { gql, useQuery } from "@apollo/client";
import { useMemo } from "react";

const GetTeacherScoresQuery = gql`
  query getTeacherScores($teacherIds: [String!]!) {
    getTeacherScores(teacherIds: $teacherIds) {
      teacherId
      studentBayesianAvg
      coordinatorScore
      finalScore
    }
  }
`;

export type TeacherScoreWithId = {
  teacherId: string;
  studentBayesianAvg: number;
  coordinatorScore: number | null;
  finalScore: number;
};

export function useTeacherScores(teacherIds: string[]) {
  const { data, loading } = useQuery(GetTeacherScoresQuery, {
    variables: { teacherIds },
    skip: teacherIds.length === 0,
    fetchPolicy: "cache-and-network",
  });

  const scoreByTeacherId = useMemo(() => {
    const list: TeacherScoreWithId[] = data?.getTeacherScores ?? [];
    return new Map(list.map((s) => [s.teacherId, s]));
  }, [data]);

  return { scoreByTeacherId, loading };
}
